import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { routing } from './release.routing';
import { AppComponent } from '../app.component';
import { AuthGuard } from '../auth.guard';
import { SharedModule } from '../shared/modules/shared.module';
import { FormsModule } from '@angular/forms';
import { ReleaseSettingsListComponent } from './release-settings-list/release-settings-list.component';
import { ReleaseSettingsEditComponent } from './release-settings-edit/release-settings-edit.component';
import { ReleaseService } from './services/release.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forRoot(routing, {}),
    SharedModule,
  ],
  declarations: [ReleaseSettingsEditComponent, ReleaseSettingsListComponent ],
  exports: [],
  providers: [AppComponent, AuthGuard, ReleaseService]
})
export class ReleaseModule { }
